import {Pipe, PipeTransform} from "@angular/core";
import {QueueStrategy} from "../../model/queueStrategy";

@Pipe({name: 'queueStrategy'})
export class QueueStrategyPipe implements PipeTransform {
    transform(value: any) {
        return QueueStrategy[value];
    }
}
